import { Injectable } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { CommonService } from './common.service';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';

@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
  private refreshInterval: any;

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private router: Router,
    private appService: AppService
  ) { }

  startRefreshing() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    this.refreshInterval = setInterval(() => {
      const refreshToken = this.commonService.getItem('refresh_token');

      if (refreshToken) {
        console.log('[TokenRefreshService] Calling refresh token API...');
        this.authService.refreshToken(refreshToken).subscribe({
          next: (res: any) => {
            const newAccessToken = res?.data?.access_token;
            if (newAccessToken) {
              this.commonService.setItem('access_token', newAccessToken);
              console.log('[TokenRefreshService] Access token refreshed successfully');
            } else {
              console.warn('[TokenRefreshService] No access token received in refresh response');
            }
          },
          error: (err) => {
            console.error('[TokenRefreshService] Immediate refresh failed', err);
            this.commonService.removeItem('access_token');
            this.commonService.removeItem('refresh_token');
            this.appService.logout();
            this.router.navigate(['/login']);
          }

        });
      } else {
        console.warn('[TokenRefreshService] No refresh token found in storage');
      }
    }, 15 * 60 * 60 * 1000); // Refresh every 15 hours
  }

  checkAndRefreshNow() {
    const token = this.commonService.getItem('access_token');
    if (!token) return;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload?.exp;
      const now = Date.now() / 1000;

      if (!exp || (exp - now) <= 60) {
        const refreshToken = this.commonService.getItem('refresh_token');
        if (!refreshToken) {
          console.warn('[TokenRefreshService] No refresh token found for immediate check');
          return;
        }

        console.log('[TokenRefreshService] Immediate refresh needed. Token expired or about to expire.');
        this.authService.refreshToken(refreshToken).subscribe({
          next: (res: any) => {
            const newAccessToken = res?.data?.access_token;
            if (newAccessToken) {
              this.commonService.setItem('access_token', newAccessToken);
              console.log('[TokenRefreshService] Token refreshed successfully on startup');
            }
          },
          error: (err) => {
            console.error('[TokenRefreshService] Immediate refresh failed', err);
            this.commonService.removeItem('access_token');
            this.commonService.removeItem('refresh_token');
            this.appService.logout();
            this.router.navigate(['/login']);
          }

        });
      }
    } catch (e) {
      console.error('[TokenRefreshService] Failed to decode token during startup check', e);
    }
  }


  stopRefreshing() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
}
